import { get } from 'lodash';
import cmsAbstractMixin from 'framework/mixins/cms/cms-abstract';


export default {
    mixins: [
        cmsAbstractMixin,
    ],
    data() {
        return {
            cmsCfg: {
                watchPath: 'cms',
                type: 'plugin',
            },
        };
    },
    computed: {
        cmsEditHelperAttrs() {
            const isEditable = (this.cmsReady && this.cmsComponentData);

            return isEditable ? {
                'data-cms-plugin-edit-helper': true,
                'data-cms-plugin-name': get(this, 'cms[1].plugin_name'),
            } : {};
        },
    },
};
